"use client";
import React from "react";

import Header from "./../components/Header";
import Pricing from "./../components/Pricing";
import AllCourse from "../components/courses/AllCourse";

const HomePage = () => {
  return (
    <>
      <Header />
      <main data-router-wrapper>
        <section
          className="js-page page challenges abyss-simple-page"
          data-router-view="challenges"
        >
          <AllCourse />

          <Pricing />
        </section>
      </main>
    </>
  );
};

export default HomePage;
